import React, { Component } from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--bed@3x.png'
import ItemImageAnimated from '../../ItemImageAnimated'
import Frame1Image from '../../../assets/images/bedroom/item--cat--f1@3x.png'
import Frame2Image from '../../../assets/images/bedroom/item--cat--f2@3x.png'
import Frame3Image from '../../../assets/images/bedroom/item--cat--f3@3x.png'
import Frame4Image from '../../../assets/images/bedroom/item--cat--f4@3x.png'
import Frame5Image from '../../../assets/images/bedroom/item--cat--f5@3x.png'
import Frame6Image from '../../../assets/images/bedroom/item--cat--f6@3x.png'
import Frame7Image from '../../../assets/images/bedroom/item--cat--f7@3x.png'
import Frame8Image from '../../../assets/images/bedroom/item--cat--f8@3x.png'
import Frame9Image from '../../../assets/images/bedroom/item--cat--f9@3x.png'

const frames = [
  Frame1Image,
  Frame2Image,
  Frame3Image,
  Frame4Image,
  Frame5Image,
  Frame6Image,
  Frame7Image,
  Frame8Image,
  // Frame9Image,
  // Frame8Image,
  Frame7Image,
  Frame6Image,
  Frame5Image,
  Frame4Image,
  Frame3Image,
  Frame2Image,
]

const path =
  'M313.65,186.6c-2.16-3.56-8.59-14.63-8.59-37.36C298.77,152.76,191.49,212,191.49,212v2.09h0v-1.94l-128.91-75h0L57,133.9l.08,0,5.64,3.29h0L191.49,212l113.57-62.86-130.23-77,0,0L140,51.66c.11-1.54-3.4-2.47-3.91-4.21-1-3.36-5.15-13.6-9.52-19.72V1.07l0,0L124.24,0,0,71.66v92.5l2.37,1.07.1-.06,11.86-6.8,31.53,18.69v0l16.72,9.49v0L141.52,232c23,14.34,38.28,31.28,49.63,31.28h.25c10.33-.17,18.4-13,34.26-21.87s62.76-35.28,62.76-35.28C308.44,195.29,319.11,195.59,313.65,186.6Z'

export default class Bed extends Component {
  constructor() {
    super()

    this.state = {
      fps: 0.00001,
    }
  }

  increaseFPS() {
    const that = this
    this.setState({ fps: 15 })

    setTimeout(() => {
      that.setState({ fps: 0.00001 })
    }, 500)
  }

  render() {
    const { fps } = this.state

    return (
      <IrregularInteraction
        path={path}
        preserveAspectRatio="xMidYMin meet"
        viewBox="0 0 315.07 263.31"
        {...this.props}
      >
        <ItemImage src={image} />
        <ItemImageAnimated
          srcs={frames}
          fps={fps}
          animate={true}
          onClick={this.increaseFPS.bind(this)}
          style={{
            pointerEvents: 'auto',
            bottom: '4.8%',
            left: '82.9%',
            position: 'absolute',
            width: '20%',
          }}
        />
      </IrregularInteraction>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Bed.js